import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Box, Button } from '@mui/material';
import { validateToken } from './utilities/validateToken';
import { useNavigate } from 'react-router-dom';

const Header = ({refresh, forceRerender}) => {
    const [fullName, setFullName] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserDetails = async () => {
            const token = localStorage.getItem('authToken');

            // If token doesn't exist, clear fullName
            if (!token) {
                setFullName('');
                return
            }
            const isValid = await validateToken(token);

            if (isValid) {
                const firstName = localStorage.getItem('first');
                const lastName = localStorage.getItem('last');
                if (firstName && lastName) {
                    setFullName(`${firstName} ${lastName}`)
                }
            } else {
                localStorage.removeItem('authToken');
                setFullName('');
            }
        };

        fetchUserDetails();
    }, [refresh]);

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('first');
        localStorage.removeItem('last');

        forceRerender();

        navigate('/login');
    }

    return (
        <AppBar position='static'>
            <Toolbar sx={{ backgroundColor: 'white'}}>
                <Box display='flex' flexGrow={1} alignItems='center'>
                    <img src={require('./logo.png')} style={{marginRight: '10px', width: '50px'}}/>
                    <Typography variant='h6' component='div' style={{color: '#081c6c'}}>
                        Leviton Payments
                    </Typography>
                </Box>
                <Typography variant='h6' component='div' style={{color: '#081c6c', marginRight: '10px'}}>
                    {fullName? fullName + '' : 'Guest'}
                </Typography>
                {fullName && ( 
                    <Button
                        variant='contained'
                        color='secondary'
                        style={{backgroundColor: '#76b900'}}
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Header;